export const DEPARTMENT_FETCH = '[Department] Department Fetch'
export const DEPARTMENT_FETCH_SUCCESS = '[Department] Department Fetch Success'
export const DEPARTMENT_FETCH_ERROR = '[Department] Department Fetch Error'
export const fetchDepartments = () => ({ type: DEPARTMENT_FETCH })